import { useMemo } from "react";

import { getResourceIRI, OrderingDirection, useFactoryListQuery } from "@sol/sdk";
import { Select, type SelectProps } from "@sol/uikit/data-entry/Select/Select";

type Props = SelectProps;

const FACTORIES_SORTED_BY_TITLE = { order: { by: "title", direction: OrderingDirection.ASC } } as const;

export function FactorySelect({ ...rest }: Props) {
    const { data, isLoading } = useFactoryListQuery(FACTORIES_SORTED_BY_TITLE, {
        useErrorBoundary: true,
        suspense: false,
    });
    const options = useMemo(
        () =>
            data?.["hydra:member"].map(factory => ({
                label: factory.title,
                value: getResourceIRI(factory),
            })) ?? [],
        [data],
    );

    return <Select showSearch optionFilterProp="label" {...rest} options={options} loading={isLoading} />;
}
